/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/addBlankArea.ts
 * FILE_ID: JOBHUB-QA-ADD-BLANK-AREA-001
 * PURPOSE: Insert the blank Area, checklist, and row into the open QA.
 */
// Reused from: packages/job-hub/src/jobs/tabs/job-qa/templates/insertQaTemplateSelection.ts (insertQaTemplateSelection)
import type { QaBlankInsertResult } from '../../qa/qaTemplateTypes'

export type BlankAreaWorkspace = {
  activeInspectionId: string | null
  api: {
    insertBlank: (body: {
      job_id: number
      inspection_id?: string | null
      area_names: string[]
    }) => Promise<QaBlankInsertResult>
  }
  invalidateAreas: () => void
  invalidateExecution: () => void
  setAreaMode: (mode: 'build') => void
  selectArea: (areaId: string) => void
  setActiveChecklistId: (checklistId: string) => void
  setError: (message: string) => void
}

export async function addBlankArea(workspace: BlankAreaWorkspace, jobId: number): Promise<void> {
  if (workspace.activeInspectionId == null) {
    workspace.setError('Select a QA first.')
    return
  }
  try {
    const created = await workspace.api.insertBlank({
      job_id: jobId,
      inspection_id: workspace.activeInspectionId,
      area_names: ['Area'],
    })
    workspace.invalidateAreas()
    workspace.invalidateExecution()
    workspace.setAreaMode('build')
    const areaId = created.areas[0]?.id
    if (areaId) workspace.selectArea(areaId)
    const checklistId = created.checklists[0]?.id
    if (checklistId) workspace.setActiveChecklistId(checklistId)
  } catch (err) {
    workspace.setError(err instanceof Error ? err.message : 'Could not add the blank checklist.')
  }
}
